import Layout from '../views/layout/Layout'

export default {
  path: '/website',
  component: Layout,
  redirect: 'noredirect',
  name: 'website',
  meta: {
    title: '官网和站内信管理',
    elicon: 'el-icon-view',
    roles: [],
  },
  children: [
    {
      path: 'case',
      name: 'website.case',
      component: () => import('@/views/mindworks/case/index.vue'),
      meta: {
        title: '作品页管理',
        roles: ['website.creative.list'],
      },
    },
    {
      path: 'subscription',
      name: 'website.subscription',
      component: () => import('@/views/mindworks/subscription/index.vue'),
      redirect: 'subscription/retain-capital',
      meta: {
        title: '留资管理',
        roles: [],
      },
      hiddenChildren: true,
      children: [
        {
          path: 'retain-capital',
          name: 'website.subscription.retain-capital',
          component: () =>
            import('@/views/mindworks/subscription/retain-capital.vue'),
          meta: {
            title: '官网留资',
            roles: ['website.subscriber.list'],
          },
        },
        {
          path: 'activity-clues',
          name: 'website.subscription.activity-clues',
          component: () =>
            import('@/views/mindworks/subscription/activity-clues.vue'),
          meta: {
            title: '活动线索',
            roles: ['website.activity.list'],
          },
        },
        {
          path: 'message',
          name: 'website.subscription.message',
          component: () => import('@/views/mindworks/subscription/message.vue'),
          meta: {
            title: '用户留言',
            roles: ['website.message.list'],
          },
        },
      ],
    },
    {
      path: 'blog',
      name: 'website.blog',
      component: () => import('@/views/mindworks/blog/index.vue'),
      meta: {
        title: '博客页管理',
        roles: ['website.blog.list'],
      },
    },
    {
      path: 'blog/creat',
      name: 'website.blog.create',
      component: () => import('@/views/mindworks/blog/edit.vue'),
      meta: {
        title: '添加博客',
        roles: ['website.blog.create'],
      },
      hidden: true,
    },
    {
      path: 'blog/edit/:id(\\d+)',
      name: 'website.blog.edit',
      component: () => import('@/views/mindworks/blog/edit.vue'),
      meta: {
        title: '修改博客',
        roles: ['website.blog.create'],
      },
      hidden: true,
    },
    {
      path: 'news',
      name: 'website.news',
      component: () => import('@/views/mindworks/news/index.vue'),
      meta: {
        title: '新闻页管理',
        roles: ['website.news.list'],
      },
    },
    {
      path: 'news/create',
      name: 'website.news.create',
      component: () => import('@/views/mindworks/news/edit.vue'),
      meta: {
        title: '添加新闻',
        roles: ['website.news.create'],
      },
      hidden: true,
    },
    {
      path: 'news/edit/:id(\\d+)',
      name: 'website.news.edit',
      component: () => import('@/views/mindworks/news/edit.vue'),
      meta: {
        title: '修改新闻',
        roles: ['website.news.create'],
      },
      hidden: true,
    },
    {
      path: 'station-letter',
      name: 'website.station-letter',
      component: () => import('@/views/mindworks/station-letter/index.vue'),
      meta: {
        title: '站内信管理',
        roles: ['message.list'],
      },
    },
    {
      path: 'station-letter/send',
      name: 'website.station-letter.send',
      component: () =>
        import('@/views/mindworks/station-letter/message/index.vue'),
      meta: {
        title: '发送站内信',
        roles: ['message.save'],
      },
      hidden: true,
    },
  ],
}
